import { render } from "./SettingsOwnerPage.vue?vue&type=template&id=079b2c92"
import script from "./SettingsOwnerPage.vue?vue&type=script&lang=js"
export * from "./SettingsOwnerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__